<template>
    <div class="page" style="background-color: #ffffff;">
        <div style="width: 100%;padding-bottom: 10px;margin-top: 5px;text-align: center" class="mypage">
            <el-radio-group v-model="tabPosition" @change="perfClick">
                <el-radio-button label="1">今天</el-radio-button>
                <el-radio-button label="2">本月</el-radio-button>
                <el-radio-button label="3">上月</el-radio-button>
                <el-button v-popover:popover>自定义</el-button>
            </el-radio-group>
        </div>
        <el-popover
            placement="bottom"
            width="400"
            ref="popover"
            trigger="click">
            <el-form label-position="left" inline class="myform" style="margin-left: 50px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="日期">
                            <el-date-picker style="width: 130px" v-model="bfrommonth" type="month" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                            </el-date-picker>
                            <el-date-picker style="width: 130px" v-model="btomonth" type="month" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-popover>
        <el-table :data="custInfos" border style="width: 100%" height="280px">
            <el-table-column prop="lable" label="名称"></el-table-column>
            <el-table-column prop="nowmonth" :label="columnname1" >
                <template slot-scope="scope">
                    {{ parseInt(scope.row.nowmonth)}}
                    <span v-if="scope.row.nownumber>0">({{scope.row.nownumber}})</span>
                </template>
            </el-table-column>
            <el-table-column prop="befogermonth" :label="columnname2" >
                <template slot-scope="scope">
                    {{ parseInt(scope.row.befogermonth)}}
                    <span v-if="scope.row.befogernumber>0">({{scope.row.befogernumber}})</span>
                </template>
            </el-table-column>
            <el-table-column prop="lv" label="增长率" >
                <template slot-scope="scope">
                    {{Math.round(scope.row.lv * 100)}}%
                </template>
            </el-table-column>
        </el-table>

        <el-tabs v-model="active" @tab-click="handleClick" :stretch="true">
            <el-tab-pane label="预约数据" name="first">
                <el-table :data="orderInfos" border style="width: 100%" height="calc(100%)">
                    <el-table-column prop="accountdate" label="日期">
                        <template slot-scope="scope">
                            {{scope.row.orderInfo.accountdate}}({{scope.row.orderInfo.roomname}})
                        </template>
                    </el-table-column>
                    <el-table-column prop="times" label="时间" >
                        <template slot-scope="scope">
                            {{scope.row.orderInfo.times}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="membername" label="顾客">
                        <template slot-scope="scope">
                            {{scope.row.orderInfo.membername}}-{{scope.row.orderInfo.cardnumber}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="proname" label="项目" >
                        <template slot-scope="scope">
                            {{scope.row.orderInfo.proname}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="护理顾客" name="second" class="mytabs" v-if="deptid!='32'">
                <el-tabs v-model="hlactive" @tab-click="hlhandleClick" border :stretch="true">
                    <el-tab-pane label="护理" name="hl">
                        <el-table :data="totalGuestInfo" border style="width: 100%;" height="calc(100%)" :show-header="false" :row-class-name="tableRowClassName">
                            <el-table-column prop="date">
                                <template slot-scope="scope">
                                    <el-form>
                                        <el-row>
                                            <el-col :span="8">
                                                <el-form-item label="会员姓名">
                                                    <span>{{scope.row.membername}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="卡号">
                                                    <span>{{scope.row.cardnumber}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="护理间隔">
                                                    <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                                <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                                <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                                <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="头皮" name="tp">
                        <el-table :data="totalTpGuestInfo" border style="width: 100%;" height="calc(100%)" :show-header="false" :row-class-name="tableRowClassName">
                            <el-table-column prop="date">
                                <template slot-scope="scope">
                                    <el-form label-position="left" inline>
                                        <el-row>
                                            <el-col :span="8">
                                                <el-form-item label="会员姓名">
                                                    <span>{{scope.row.membername}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="卡号">
                                                    <span>{{scope.row.cardnumber}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="护理间隔">
                                                    <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                                <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                                <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                                <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="全部" name="all">
                        <el-table :data="totalAllGuestInfo" border style="width: 100%;" height="calc(100%)" :show-header="false" :row-class-name="tableRowClassName">
                            <el-table-column prop="date">
                                <template slot-scope="scope">
                                    <el-form label-position="left" inline>
                                        <el-row>
                                            <el-col :span="8">
                                                <el-form-item label="会员姓名">
                                                    <span>{{scope.row.membername}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="卡号">
                                                    <span>{{scope.row.cardnumber}}</span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="护理间隔">
                                                    <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                            <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                            <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                            <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                        </el-col>
                                    </el-row>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="我的数据" name="third">
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix" style="text-align: center">
                        <el-radio-group v-model="mytabPosition" @change="myData">
                            <el-radio-button label="1">今天</el-radio-button>
                            <el-radio-button label="2">本月</el-radio-button>
                            <el-radio-button label="3">上月</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="text item">
                        <el-form label-position="left" inline size="mini">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="总提成">
                                        <span>{{ $parseInt(stafftotalperf.totalcomm) }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="现金提成">
                                        <span>{{ $parseInt(stafftotalperf.totalcashcomm)}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="卡付提成">
                                        <span>{{$parseInt(stafftotalperf.totalcardcomm)}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="其他提成">
                                        <span>{{$parseInt(stafftotalperf.totalothercomm)}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="人头提成">
                                        <span>{{$parseInt(stafftotalperf.headamount)}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="兑换提成">
                                        <span>{{$parseInt(stafftotalperf.exchangecomm)}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="附带成长">
                                        <span>{{$parseInt(stafftotalperf.growup)}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <router-link to='/empperfdetal'>
                                        <el-button type="text">查看明细</el-button>
                                    </router-link>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-card>
            </el-tab-pane>
            <el-tab-pane label="设置" name="four" v-if="1==2">
                <el-form label-position="left" label-width="80px" style="margin: 10px;" class="myform" size="mini">
                    <el-form-item label="头像">
                        <el-upload class="avatar-uploader" :action="uploadFile" :show-file-list="false"
                                   :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="艺名">
                        <el-input v-model="staff.staffnickname"></el-input>
                    </el-form-item>
                    <el-form-item label="休息日">
                        <el-select v-model="staff.restday" placeholder="请选择休息日" style="width: 100%;">
                            <el-option label=" " :value="0"></el-option>
                            <el-option label="周一" :value="1"></el-option>
                            <el-option label="周二" :value="2"></el-option>
                            <el-option label="周三" :value="3"></el-option>
                            <el-option label="周四" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="个人介绍">
                        <el-input type="textarea" v-model="staff.introduce"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="updateStaff">保存</el-button>
                        <el-button @click="openStaffRest">新增请假</el-button>
                    </el-form-item>

                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-dialog title="新增请假信息" :visible.sync="dialogVisible" width="100%">
            <el-form label-position="left" label-width="80px" style="margin: 10px;" class="myform">
                <el-form-item label="请假类型">
                    <el-select v-model="addStaffRest.leavetype" placeholder="请选择请假类型" style="width: 100%;">
                        <el-option :label="item.constantname" :value="item.constantid" v-for="(item,index) in leaves" :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期">
                    <el-date-picker style="width: 100%" v-model="addStaffRest.fromdate" type="date" placeholder="开始日期"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker style="width: 100%" v-model="addStaffRest.todate" type="date" placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveStaffRest">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            uploadFile: process.env.API_ROOT+"file/fileUpload?token=" + localStorage.getItem("token"),
            staffRest: {
                storeid: "",
                sysbillid: "",
                staffid: "",
                leavetype: "",
                fromdate: "",
                todate: "",
                status: 99,
            },
            addStaffRest: {},
            dialogVisible: false,
            imageUrl: "",
            deptid: "31",
            hlisload: false,
            tpisload: false,
            allisload: false,
            hlactive: "hl",
            columnname1: "今天",
            columnname2: "昨天",
            bfrommonth: "",
            btomonth: "",
            totalTpGuestInfo: [],
            totalAllGuestInfo: [],
            totalGuestInfo: [],
            tabPosition: "1",
            mytabPosition: "1",
            active: "first",
            orderInfos: [],
            fromdate: this.$moment().format("YYYY-MM-DD"),
            todate: this.$moment().format("YYYY-MM-DD"),
            bfromdate: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
            btodate: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
            stafftotalperf: {},
            storeid: "",
            staffid: "",
            custfromdate: this.$moment().format("YYYY-MM-DD"),
            custtodate: this.$moment().format("YYYY-MM-DD"),
            isloadcust: false,
            isyy: false,
            custInfos: [],
            iscust: false,
            staff: {},
            leaves: [],
        }
    },
    created: function() {
        this.storeid=localStorage.getItem("storeid");
        this.staffid=localStorage.getItem("staffid");
        this.deptid=localStorage.getItem("deptid");
        if(this.deptid=="32"){
            this.getBeautyDataByStaffId();
        }
        else {
            this.getHairDataByStaffId();
            this.getLeaveInfo();
        }
        this.getOrderInfoByFromdateTo();
        //console.log(this.baseImageUrl);
        //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjI0MDgzMDUzLCJleHAiOjE2MjQxNjk0NTN9.yVBtCcsvOmfzlJ32tBEJWvZp3iZjEki0NEbRWsbdy_Y");
        /*let userId = this.$getUrlKey("userId");
        let code = this.$getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getCorpidCode" +
                "" +
                "?state=6";
        }*/
        //this.getHairDataByStaffId();
    },
    methods: {
        updateStaffIcon(icon) {
            let staffid = localStorage.getItem("staffid");
            this.$post("newcardapp/updateStaffIcon", {
                staffid: staffid,
                icon: icon
            }).then(res => {
                if (res.sucess) {

                } else {
                    this.$message.error(res.message);
                }
            });
        },
        openStaffRest() {
            this.addStaffRest = this.$copy(this.staffRest);
            this.dialogVisible = true;
        },
        saveStaffRest() {
            if (!this.addStaffRest.leavetype) {
                this.$message.error("请选择请假类型");
                return;
            }
            if (!this.addStaffRest.fromdate) {
                this.$message.error("请选择开始日期");
                return;
            }
            if (!this.addStaffRest.todate) {
                this.$message.error("请选择结束日期");
                return;
            }
            this.addStaffRest.storeid = this.staff.storeid;
            this.addStaffRest.staffid = this.staff.staffid;
            this.$postw("newcardapp/saveStaffRest", this.addStaffRest).then(res => {
                if (res.sucess) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getLeaveInfo() {
            this.$post("newcardapp/getLeaveInfo").then(res => {
                if (res.sucess) {
                    this.leaves = res.object;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        updateStaff() {
            this.$postw("newcardapp/updateStaff", this.staff).then(res => {
                if (res.sucess) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleAvatarSuccess(res, file) {
            this.staff.icon = res.object;
            this.imageUrl=this.baseImageUrl+res.object;
            this.updateStaffIcon(this.staff.icon);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        openCourse(cardid) {
            this.$router.push({
                path: "/cardcourse",
                query: {
                    cardid: cardid
                }
            });
        },
        monthchange(e) {
            if (this.bfrommonth && this.btomonth) {
                this.fromdate = this.bfrommonth + "-01";
                this.todate = this.$moment(this.fromdate).endOf('month').format('YYYY-MM-DD');
                this.bfromdate = this.btomonth + "-01";
                this.btodate = this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD');
                this.columnname1 = this.fromdate.substring(5, 7) + "月";
                this.columnname2 = this.bfromdate.substring(5, 7) + "月";
                this.bfrommonth = "";
                this.btomonth = "";
                this.$refs["popover"].doClose();
                if (this.deptid == "32") {
                    this.getBeautyDataByStaffId();
                } else {
                    this.getHairDataByStaffId();
                }
            }
        },
        myData(e) {
            console.log(e);
            if (e == 1) {
                this.custfromdate = this.$moment().format("YYYY-MM-DD");
                this.custtodate = this.$moment().format("YYYY-MM-DD");
            } else if (e == 2) {
                this.custfromdate = this.$moment().startOf('month').format('YYYY-MM-DD');
                this.custtodate = this.$moment().endOf('month').format('YYYY-MM-DD');
            } else if (e == 3) {
                let days = this.$moment(this.$moment().format('YYYY-MM-') + '01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.custfromdate = days + "-01";
                this.custtodate = this.$moment(this.custfromdate).endOf('month').format('YYYY-MM-DD');
                //console.log(this.custtodate);
                //console.log(this.$moment(this.custfromdate).endOf('month').format('YYYY-MM-DD'));
            }
            this.getStaffSalaryById(this.mytabPosition);
        },
        tableRowClassName(row, rowIndex) {
            if (row.row.hldays < 10) {
                return 'blue';
            } else if (row.row.hldays < 20) {
                return 'orange'
            } else if (row.row.hldays >= 20) {
                return 'red'
            }
            return '';
        },
        hlhandleClick(e, event) {
            if (e.name == "hl") {
                if (this.hlisload == false) {
                    this.getHeadStaffCardInfo(1);
                    this.hlisload = true;
                }
            } else if (e.name == "tp") {
                if (this.tpisload == false) {
                    this.getHeadStaffCardInfo(2);
                    this.tpisload = true;
                }
            } else if (e.name == "all") {
                if (this.allisload == false) {
                    this.getHeadStaffCardInfo(3);
                    this.allisload = true;
                }
            }
        },
        openCardFiles(item) {
            this.$router.push({
                path: "/haircustfiles",
                query: {
                    cardid: item.cardid
                }
            });
        },
        getBeautyDataByStaffId() {
            this.$post("staff/getBeautyDataByStaffId", {
                storeid: this.storeid,
                fromdate: this.fromdate,
                todate: this.todate,
                bfromdate: this.bfromdate,
                btodate: this.btodate,
                staffid: this.staffid
            }).then(res => {
                if (res.sucess) {
                    this.custInfos = res.object;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getHairDataByStaffId() {
            this.$post("staff/getHairDataByStaffId", {
                storeid: this.storeid,
                fromdate: this.fromdate,
                todate: this.todate,
                bfromdate: this.bfromdate,
                btodate: this.btodate,
                staffid: this.staffid
            }).then(res => {
                if (res.sucess) {
                    this.custInfos = res.object;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        openCardTranHistory(item) {
            this.$router.push({
                path: "/cardtranhistory",
                query: {
                    cardid: item.cardid
                }
            });
        },
        getHeadStaffCardInfo(type) {
            this.$post("ddstaff/getHeadStaffByHlCardInfo", {
                storeid: this.storeid,
                staffid: this.staffid,
                type: type
            }).then(res => {
                if (res.sucess) {
                    if (type == 1) {
                        this.totalGuestInfo = res.object;
                    } else if (type == 2) {
                        this.totalTpGuestInfo = res.object;
                    } else if (type == 3) {
                        this.totalAllGuestInfo = res.object;
                    }
                    //this.isloadcust=true;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getOrderInfoByFromdateTo() {
            this.$post("order/getOrderInfoByFromdateTo", {
                storeid: this.storeid,
                staffid: this.staffid
            }).then(res => {
                if (res.sucess) {
                    this.orderInfos = res.object;
                    this.isyy = true;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleClick(e,event){
            if("second"==e.name){
                this.hlactive="hl";
                if(this.hlisload==false){
                    this.getHeadStaffCardInfo(1);
                }
            }
            else if("third"==e.name){
                if(!this.iscust){
                    this.getStaffSalaryById(this.mytabPosition);
                }
            }
        },
        getCorpUserInfo(staffid){
            this.$post("wechat/getCorpUserInfo",{staffid:staffid}).then(res=>{
                if(res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        //如果钉钉没找到就关闭页面
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        if(data.staff.icon){
                            this.imageUrl=this.baseImageUrl+data.staff.icon;
                        }
                        this.storeid=data.staff.storeid;
                        this.staffid=data.staff.staffid;
                        this.deptid=data.staff.deptid;
                        if(this.deptid=="32"){
                            this.getBeautyDataByStaffId();
                        }
                        else {
                            this.getHairDataByStaffId();
                            this.getLeaveInfo();
                        }
                        this.getOrderInfoByFromdateTo();
                    }
                }
            });
        },
        perfClick(e){
            if(e=="1"){
                this.fromdate=this.$moment().format("YYYY-MM-DD");
                this.todate=this.$moment().format("YYYY-MM-DD");
                this.bfromdate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.btodate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.columnname1="今天";
                this.columnname2="昨天";
            }
            else if(e=="2"){
                this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.bfromdate=days+"-01";
                this.btodate=this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD');
                this.columnname1="本月";
                this.columnname2="上月";
            }
            else if(e=="3"){
                let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.fromdate=days+"-01";
                this.todate=this.$moment(this.fromdate).endOf('month').format('YYYY-MM-DD');
                this.columnname1=days.substring(5,7)+"月";

                days=this.$moment(this.fromdate).startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.bfromdate=days+"-01";
                this.btodate=this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD');
                this.columnname2=days.substring(5,7)+"月";
            }
            if(this.deptid=="32"){
                this.getBeautyDataByStaffId();
            }
            else {
                this.getHairDataByStaffId();
            }
        },
        getStaffSalaryById(type){
            this.$post("calsalary/getStaffSalaryByIdNew",{storeid:this.storeid,staffid:this.staffid,type:type}).then(res=>{
                if(res.sucess){
                    if(res.object){
                        this.stafftotalperf = res.object;
                    }
                    else{
                        this.stafftotalperf = {};
                    }
                }
                else{
                    this.$message.error(res.message);
                }
            });
        }
    }
}
</script>


<style style lang="scss" rel="stylesheet/scss">
.page .el-form-item{
    margin-bottom:0px;
}

.myform .el-form-item {
    margin-bottom: 0px;
}

.page .el-card {
    border: 0px;
}
.page .el-radio-button__inner, .el-radio-group{
    display: block;
}

.page .el-tabs__content {
    height: calc(100% - 30px);
}

.page .el-tabs{
    height: calc(100% - 349px);
}

.page .el-tab-pane{
    height: calc(100%);
}

.page .el-table{
    font-size:10px;
}

.page .el-form-item__content{
    font-size:10px;
}

.page .el-form-item__label{
    font-size:10px;
}

.page .el-tabs__header{
    margin:0 0 2px;
}

.page .el-card__header{
    padding:2px 2px;
}

.mypage .el-tabs__header{
    margin:0 0 15px;
}

.myform .el-form-item{
    margin-right:0px;
}

.page .el-table td, .el-table th{
    padding:5px 0;
}


.el-table .blue {
    background: #dbf6cb;
}

.el-table .orange {
    background: #fcebcd;
}

.el-table .red {
    background: #fcb3b3;
}

.mytabs .el-tabs__content{
    height: calc(100%);
}

.mytabs .el-tabs{
    height: calc(100%);
}

.mytabs .el-table__body{
    margin-bottom: 40px;
}


.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
}

.avatar {
    width: 108px;
    height: 108px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/hair/empmanagernew.vue